import { MktTopBar, MktTopBarNestableItem } from '@securitize/reactjs-mkt-ui';
import { TopBarLinkModel } from '../../data/builderio/top-bar/top-bar-link.model';
import { Link } from 'react-router-dom';
import secPositive from '@securitize/assets-sec-ui/dist/logos/svg/sec-trademark-positive.svg';
import secNegative from '@securitize/assets-sec-ui/dist/logos/svg/sec-trademark-negative.svg';

interface TopBarProps {
  topBarLinks: TopBarLinkModel[] | [];
  variant?: 'dark' | 'light' | 'transparent';
  transparentVariant: 'light' | 'dark';
  fixedVariant: 'light' | 'dark' | null;
}

export const TopBar: React.FC<TopBarProps> = ({
  topBarLinks,
  variant = 'dark',
  transparentVariant = 'dark',
  fixedVariant,
}) => {
  const homeItem: MktTopBarNestableItem = topBarLinks
    .filter(({ data }) => data.type === 'home')
    .map(({ data }: TopBarLinkModel, index) => {
      return {
        id: index,
        label: data.label,
        url: data.url,
      };
    })[0];

  return (
    <MktTopBar
      homeItem={homeItem}
      linkComponent={Link}
      variant={variant}
      transparentVariant={transparentVariant}
      fixedVariant={fixedVariant}
      negativeLogo={secNegative}
      positiveLogo={secPositive}
    />
  );
};
